export default __webpack_public_path__ + "static/media/faq.8bd288e5.svg";